import { jsx as n, jsxs as p, Fragment as h } from "react/jsx-runtime";
import { forwardRef as B, useMemo as L, Children as I, isValidElement as R, cloneElement as b } from "react";
import { ButtonIcon as g } from "./button-icon.js";
import { ButtonLabel as x } from "./button-label.js";
import { ButtonLoading as E } from "./button-loading.js";
import { ButtonRoot as j } from "./button-root.js";
const o = B(
  (s, d) => {
    const { asChild: r = !1, children: e, icon: t, iconPosition: i = "start", ...a } = s, u = L(() => {
      var m;
      const c = (f) => /* @__PURE__ */ p(h, { children: [
        t && i === "start" ? /* @__PURE__ */ n(o.Icon, { children: t }) : null,
        /* @__PURE__ */ n(o.Label, { children: f }),
        t && i === "end" ? /* @__PURE__ */ n(o.Icon, { children: t }) : null
      ] });
      if (!r)
        return c(e);
      const l = I.toArray(e)[0];
      return R(l) ? b(l, void 0, c((m = l.props) == null ? void 0 : m.children)) : null;
    }, [r, e, t, i]);
    return /* @__PURE__ */ n(o.Root, { ref: d, asChild: r, ...a, children: u });
  }
);
o.displayName = "Button";
o.Root = j;
o.Label = x;
o.Icon = g;
o.Loading = E;
export {
  o as Button
};
//# sourceMappingURL=button.js.map
